import { raise } from 'xstate5';

import type { CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Raise the event to change the dressing mode to "on the side" when the active
 * ingredients are not mixable.
 */
export const raiseChangeToOnTheSideIfNeeded: CustomizationMachineAction = raise({
  type: 'customization.dressing-mode.change-to-on-the-side-if-needed',
});
